import { DatabaseCoverage } from 'dashboard/models/database-coverage';
import {
  DatabaseCoverageActions,
  DatabaseCoverageActionType,
} from 'dashboard/redux/actions/database-coverage';

export interface DatabaseCoverageState {
  databaseCoverage: DatabaseCoverage | undefined;
}

export const initialState: DatabaseCoverageState = {
  databaseCoverage: undefined,
};

const databaseCoverageReducer = (
  state: DatabaseCoverageState = initialState,
  action: DatabaseCoverageActions,
): DatabaseCoverageState => {
  switch (action.type) {
    case DatabaseCoverageActionType.SetDatabaseCoverage: {
      return {
        ...state,
        databaseCoverage: action.payload.databaseCoverage,
      };
    }

    default:
      return state;
  }
};

export default databaseCoverageReducer;
